

































































































































































































































import Vue, { PropType } from 'vue';
import { PaginationData } from '@/types';
import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
import FieldInput from '@/components/form/FieldInput.vue';
import ModalWrapper from '@/components/ModalWrapper.vue';
import Preloader from '@/components/preloader/Preloader.vue';
import { ICreative } from '@/types/campaign/creatives';

export default Vue.extend({
  name: 'SelectCreatives',
  components: {
    FieldCheckbox,
    FieldInput,
    ModalWrapper,
    Preloader,
  },

  props: {
    paginationData: {
      type: Object as PropType<PaginationData>,
      required: false,
    },
    creativesData: {
      type: Array as PropType<Array<ICreative>>,
      required: true,
      default: () => [],
    },
    uploadedCreatives: {
      type: Array as PropType<Array<string>>,
      required: false,
      default: () => [],
    },
    sortCreatives: {
      type: String,
      required: false,
      default: '',
    },
    loadData: {
      type: Boolean,
      required: false,
      default: false,
    },
    modal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  mounted() {
    this.observer = new IntersectionObserver((entry) => {
      if (entry[0].isIntersecting) {
        this.getData(true);
      }
    });

    this.observer.observe(this.$refs.loadMoreCreatives);
  },

  destroyed() {
    this.observer.disconnect();
  },

  watch: {
    modal: function () {
      this.isOpen = this.modal;
    },
  },

  computed: {
    creatives(): Array<ICreative> {
      return this.creativesData.filter(
        (creative) => !this.uploadedCreatives.includes(creative.id.toString())
      );
    },
  },

  methods: {
    getData(concatPage: boolean) {
      if (
        concatPage &&
        (+this.paginationData?.currentPage >= +this.paginationData.pageCount ||
          this.requestIsExecute)
      ) {
        return;
      }
      let width: null | number = null;
      let height: null | number = null;
      if (this.filter.size) {
        const sizeArr = this.filter.size.split('x');
        if (sizeArr[0] && +sizeArr[0]) {
          width = +sizeArr[0];
        }
        if (sizeArr[1] && +sizeArr[1]) {
          height = +sizeArr[1];
        }
      }
      this.requestIsExecute = true;
      const result = new Promise((resolve) =>
        this.$emit(
          'loadData',
          {
            page: concatPage
              ? +this.paginationData.currentPage + 1
              : +this.paginationData.currentPage,
            title: this.filter.title,
            description: this.filter.description,
            width,
            height,
            sort: this.sortCreatives,
          },
          resolve
        )
      );
      result.then((value) => (this.requestIsExecute = false));
    },
    selectAll(value) {
      if (value) {
        this.creatives.map((item: ICreative) => {
          if (item.id && !this.checked(item.id)) {
            this.selectedCreative.push(item.id);
          }
        });
      } else {
        this.selectedCreative = [];
      }
    },
    checked(id: string) {
      return this.selectedCreative.indexOf(id) >= 0;
    },
    addSelected(id: string) {
      if (this.checked(id)) {
        this.selectedCreative = this.selectedCreative.filter(
          (item) => item != id
        );
      } else {
        this.selectedCreative.push(id);
      }
    },
    submit() {
      this.$emit(
        'submit',
        this.selectedCreative.map((id: string): ICreative => {
          const creative = this.creativesData.find((item: ICreative) => {
            return item.id === id;
          });
          if (!creative) {
            throw new Error('Ошибка выбора креативов');
          }
          creative.sourceImg = {
            img: creative.img,
            width: creative.width,
            height: creative.height,
          };
          return creative;
        })
      );
      this.selectedCreative = [];
      this.$emit('input');
    },
  },

  data() {
    return {
      requestIsExecute: false,
      elCreatives: null as HTMLElement | null,
      isOpen: false,
      selectedCreative: [] as Array<string>,
      filter: {
        activeTitle: false,
        title: '',
        activeSize: false,
        size: '',
        activeDescription: false,
        description: '',
      },
      observer: null as any,
    };
  },
});
